import React, { createContext, useMemo, ReactNode } from 'react';

// project imports
import config from 'config';
import { useLocalStorage } from 'hooks/useLocalStorage';

// ==============================|| TYPES ||============================== //

export interface ConfigState {
  // Define the shape of your config object if known, e.g.:
  // themeMode: 'light' | 'dark';
  // direction: 'ltr' | 'rtl';
  // [key: string]: any;
  [key: string]: any;
}

export interface ConfigContextType {
  state: ConfigState;
  setState: (value: ConfigState) => void;
  setField: (key: string, value: any) => void;
  resetState: () => void;
}

interface ConfigProviderProps {
  children: ReactNode;
}

// ==============================|| CONFIG CONTEXT ||============================== //

export const ConfigContext = createContext<ConfigContextType | undefined>(undefined);

// ==============================|| CONFIG PROVIDER ||============================== //

export const ConfigProvider: React.FC<ConfigProviderProps> = ({ children }) => {
  const { state, setState, setField, resetState } = useLocalStorage<ConfigState>('lexauto-config', config);

  const memoizedValue = useMemo(() => ({ state, setState, setField, resetState }), [state, setField, setState, resetState]);

  return <ConfigContext.Provider value={memoizedValue}>{children}</ConfigContext.Provider>;
};
